(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[55],{

/***/ 9151:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs",
      function () {
        return __webpack_require__(2421);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


function BlogListCard(param) {
    let { data  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: "block",
        href: "/blogs/".concat(data.slug),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: data.title_image,
                alt: data.title,
                className: "h-[200px] object-cover w-full"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "text-[22px] md:text-[18px] mt-[20px] text-center leading-[120%]",
                children: [
                    " ",
                    data.title,
                    "  "
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BlogListCard);


/***/ }),

/***/ 1370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function InfiniteLoader(param) {
    let { show , message , actionOnShow , extras ={}  } = param;
    const intersectionOptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return {
            root: null,
            rootMargin: "0px",
            threshold: 0
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const loader = document.getElementById("inifinte-loader");
        const observer = new IntersectionObserver(intersectionCallback, intersectionOptions);
        if (loader) observer.observe(loader);
        return ()=>{
            if (loader) observer.unobserve(loader);
        };
    }, [
        extras
    ]);
    const intersectionCallback = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                actionOnShow();
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
            id: "inifinte-loader",
            className: "text-theme-orange",
            children: [
                " ",
                message,
                " "
            ]
        })
    });
}
InfiniteLoader.defaultProps = {
    show: false,
    message: "loading more..."
};
/* harmony default export */ __webpack_exports__["Z"] = (InfiniteLoader);


/***/ }),

/***/ 2868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function Title(param) {
    let { title  } = param;
    const Title = "".concat(title, " | APIdrug Platform");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: Title
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 2421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2868);
/* harmony import */ var _components_Blog_ListCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1198);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_General_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(348);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);
/* harmony import */ var _store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1266);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7294);
/* harmony import */ var _components_General_InfiniteLoader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1370);
/* harmony import */ var _MixPanel__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5067);










function BlogHome() {
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    let { blogList  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)((state)=>state.core);
    const [searchInput, setSearchInput] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)("");
    const [showSearchResults, setShowSearchResults] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false);
    const currentPage = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(1);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(()=>{
        const params = {
            page: 1,
            page_size: 30
        };
        dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .getBlogList */ .De)(params));
        _MixPanel__WEBPACK_IMPORTED_MODULE_9__/* .MixpanelTracking.getInstance */ .n.getInstance().pageViewed({});
    }, []);
    const handleSearch = (event)=>{
        setSearchInput(()=>event.target.value);
        setShowSearchResults(()=>true);
        dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .getBlogList */ .De)({
            page: 1,
            page_size: 10,
            search: event.target.value
        }));
    };
    const loadMoreBlogs = ()=>{
        currentPage.current = currentPage.current + 1;
        if (blogList.data.next) {
            dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .getBlogList */ .De)({
                page: currentPage.current,
                page_size: 30,
                type: "append"
            }));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "py-10 min-h-[50vh]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: "Blogs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-center flex-col md:w-[65%] lg:w-[50%] md:mx-auto",
                children: [
                    blogList.list.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "ml-auto w-[50%] relative mb-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_General_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            outerProperties: "border rounded h-[40px]",
                            properties: "rounded h-[38px]",
                            placeholder: "Search By Blog",
                            suffix: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 1.5,
                                stroke: "currentColor",
                                className: "w-4 h-4 text-[gray] mr-1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                                })
                            }),
                            search: true,
                            searchResults: showSearchResults && blogList.searchList.map((blog)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    className: "block rounded py-2 my-1 px-2 hover:bg-[#D4D9E7]",
                                    href: "/blogs/".concat(blog.slug),
                                    children: blog.title
                                }, blog.id)),
                            onChange: handleSearch,
                            value: searchInput,
                            onBlur: ()=>{
                                setTimeout(()=>{
                                    setShowSearchResults(()=>false);
                                }, 300);
                            }
                        })
                    }),
                    blogList.list.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full mb-[30px]",
                                onClick: ()=>console.log(blogList),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: "w-full",
                                    src: blogList.list[0].title_image,
                                    alt: blogList.list[0].title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "px-[20px] text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "text-[36px] font-semibold cursor-pointer hover:underline",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: "/blogs/".concat(blogList.list[0].slug),
                                            children: blogList.list[0].title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
                                        className: "font-light text-[16px] mt-[24px] inline-block",
                                        children: [
                                            " ",
                                            blogList.list[0].brief_description,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            blogList.list.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:w-[45%] md:mx-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[3px] w-full lg:w-[95%] lg:mx-auto bg-[#000000] my-[50px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "font-semibold text-[32px] mb-[28px] text-center",
                        children: "All articles"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-[20px] md:grid md:grid-cols-2 gap-x-[30px] gap-y-[50px]",
                        children: blogList.list.map((blog, index)=>index !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-[40px] md:mb-0 cursor-pointer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Blog_ListCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    data: blog
                                })
                            }, blog.id))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center mt-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_General_InfiniteLoader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            show: blogList.data.next && true,
                            message: "Loading More...",
                            actionOnShow: loadMoreBlogs,
                            extras: blogList
                        })
                    })
                ]
            }),
            blogList.list.length === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "flex items-center justify-center text-3xl text-theme-black",
                children: " No Blogs Yet! "
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (BlogHome);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(9151); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);